import React, { useCallback } from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';

import {
  learnerEmailSelector,
  setFieldErrors,
  setLearnerEmail,
} from 'features/neovarsityManagement';
import Field from 'components/Field';
import Input from 'components/Input';
import styles from './ManageEmailField.module.scss';

function ManageEmailField() {
  const dispatch = useDispatch();
  const learnerEmail = useSelector(learnerEmailSelector);

  const handleEmailInputChange = useCallback(
    (e) => {
      batch(() => {
        dispatch(setFieldErrors(null));
        dispatch(setLearnerEmail(e.target.value));
      });
    },
    [dispatch]
  );

  return (
    <div className="row">
      <Field
        label="Learner Email:"
        className={styles.inputHeader}
        name="addCreditLearnerEmailField"
        prefixName="addCreditLearnerEmailField"
      >
        <Input
          className={classNames(styles.entityInput, 'p-b-xxs')}
          onChange={handleEmailInputChange}
          value={learnerEmail}
          placeholder="Learner Email"
        />
      </Field>
    </div>
  );
}

export default ManageEmailField;
